import { cn } from '~/lib/utils'

/**
 * Déclencheur « chip » des filtres de page (maquettes Prévisions, Contrôle rupture, Logistique) :
 * texte de marque vert sur fond transparent. Les écrans ajoutent leur fond et leur survol via `cn`.
 */
export const FILTER_CHIP_TRIGGER =
  'h-9 w-auto gap-2.5 rounded-lg border-transparent bg-transparent px-2 font-brand text-[18px] font-semibold leading-[20px] text-[#4f6a47] shadow-none [&_svg]:text-[#4f6a47]'

/** Variante pleine (fond clair, survol plus foncé) des chips posés hors d'une barre de filtres. */
export const FILTER_CHIP_TRIGGER_FILLED = cn(
  FILTER_CHIP_TRIGGER,
  'shrink-0 bg-[#f9f8f1] hover:bg-[#f0ede2]',
)

export const filterBarTriggerClass = (open: boolean, muted = false) =>
  cn(
    FILTER_CHIP_TRIGGER,
    'hover:bg-background-100 flex shrink-0 items-center',
    open && 'bg-background-100',
    muted && 'text-sage-500 [&_svg]:text-sage-500',
  )

export const filterBarDetailClass = 'text-sage-500 font-medium whitespace-nowrap'

export const filterBarChevronClass = (open: boolean) =>
  cn('size-4 shrink-0 transition-transform', open && 'rotate-180')
